import React from 'react'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { Order } from '@/utils/sorting'
import { GlobalReportLibraryColumnProps } from '@/state/reports/models'
import { TableHeadCellPropsType } from '@/state/ui/global/models'

type Props = {
  order: Order
  orderBy: keyof GlobalReportLibraryColumnProps
  createSortHandler: (
    property: keyof GlobalReportLibraryColumnProps,
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  headCells: TableHeadCellPropsType<GlobalReportLibraryColumnProps>[]
}

function ReportTableHeadComponent({
  order,
  orderBy,
  createSortHandler,
  headCells,
}: Props) {
  return (
    <TableHead>
      <TableRow>
        {headCells?.map((item) => (
          <TableCell
            sortDirection={orderBy === item.id ? order : false}
            key={item.id}
            sx={{ minWidth: item.width || 'auto' }}
          >
            <TableSortLabel
              IconComponent={KeyboardArrowDown}
              active={orderBy === item.id}
              direction={order}
              onClick={createSortHandler(item.id)}
            >
              {item.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default ReportTableHeadComponent
